export default "__VITE_ASSET__f941ff00__"